export enum ProxyTypeEnum {
  NotSet = '',
  S3Proxy = "s3-proxy",
  CFProxy = "cf-proxy",
}
